import { useEffect, useRef, useState } from 'react'
import { api, ApiError } from '../api.js'
import { Brandmark } from '../components/Brandmark.js'
import { useText } from '../i18n.js'
import { useNavigate } from '../router.js'
import { markShowcase } from './visitIntent.js'

/**
 * Die Zwischenstation zwischen Landingpage und Vorführung.
 *
 * Sie besteht aus demselben Grund wie `DemoPage`: Die statische Seite trägt
 * kein Skript — die Sicherheitsrichtlinie verbietet Inline-Code — und kann
 * deshalb selbst kein POST absetzen. Ein schlichter Link hierher genügt.
 *
 * Was danach passiert, ist der gewöhnliche Gastweg: eine Gast-Sitzung, ein
 * Board, ein Wartebildschirm. Nur den Namen fragt niemand ab.
 */
export function ShowcasePage(): React.ReactElement {
  const t = useText()
  const [error, setError] = useState<string | null>(null)
  const navigate = useNavigate()
  /*
   * React ruft Effekte im Strict-Modus doppelt auf. Ohne diese Sperre entstünden
   * zwei Gast-Sitzungen, von denen die zweite die erste aus dem Cookie
   * verdrängt — sichtbar würde das nicht, bezahlt wird es trotzdem.
   */
  const started = useRef(false)

  useEffect(() => {
    if (started.current) return
    started.current = true
    api
      .startShowcase()
      .then((showcase) => {
        markShowcase(showcase.boardId)
        navigate(`/b/${showcase.boardId}`, true)
      })
      .catch((caught: unknown) =>
        setError(caught instanceof ApiError ? caught.message : t('showcase.failed')),
      )
  }, [navigate, t])

  return (
    <div className="auth-screen brand-surface">
      <div className="auth-card">
        <Brandmark />
        {error ? (
          <>
            <p className="form-error">{error}</p>
            <a className="button ghost" href="/de/">
              {t('common.back')}
            </a>
          </>
        ) : (
          <p className="auth-lead">{t('showcase.preparing')}</p>
        )}
      </div>
    </div>
  )
}
